import { render } from "./SelectOrderStatus.vue?vue&type=template&id=57146bb1&ts=true"
import script from "./SelectOrderStatus.vue?vue&type=script&lang=ts"
export * from "./SelectOrderStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__